// import React, { useState, useEffect, useContext } from 'react';
// import { Calendar, Clock, Users, Plus, X, Edit2, Trash2, Check, AlertCircle } from 'lucide-react';
// import Layout from "../components/Layout";
// import { Sidebar } from "../components";
// import AuthContext from "../contexts/AuthContext";
// import {ConferenceRoomItem} from "../data";

// // Sidebar items for meeting room booking
// const BookingMenuItems = [
//   { name: 'Meeting Room Booking', icon: Calendar, path: '/booking/calendar' }
// ];

// const MeetingRoomBooking = () => {
//   const { user } = useContext(AuthContext);
//   const [currentDate, setCurrentDate] = useState(new Date());
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [bookings, setBookings] = useState([]);
//   const [showBookingModal, setShowBookingModal] = useState(false);
//   const [selectedSlot, setSelectedSlot] = useState(null);
//   const [bookingForm, setBookingForm] = useState({
//     startTime: '',
//     endTime: '',
//     description: '',
//     date: ''
//   });
//   const [editingBooking, setEditingBooking] = useState(null);

//   // Initialize with some sample bookings
//   useEffect(() => {
//     const sampleBookings = [
//       {
//         id: 1,
//         userId: 1,
//         userName: 'John Doe',
//         date: new Date().toISOString().split('T')[0],
//         startTime: '09:00',
//         endTime: '10:00',
//         description: 'Team Standup',
//         status: 'confirmed'
//       },
//       {
//         id: 2,
//         userId: 2,
//         userName: 'Jane Smith',
//         date: new Date().toISOString().split('T')[0],
//         startTime: '14:00',
//         endTime: '15:30',
//         description: 'Client Meeting',
//         status: 'confirmed'
//       }
//     ];
//     setBookings(sampleBookings);
//   }, []);

//   // Generate week dates starting from current date
//   const getWeekDates = () => {
//     const dates = [];
//     for (let i = 0; i < 7; i++) {
//       const date = new Date(currentDate);
//       date.setDate(currentDate.getDate() + i);
//       dates.push(date);
//     }
//     return dates;
//   };

//   // Generate time slots (15-minute intervals)
//   const generateTimeSlots = () => {
//     const slots = [];
//     for (let hour = 8; hour < 18; hour++) {
//       for (let minute = 0; minute < 60; minute += 15) {
//         const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
//         slots.push(time);
//       }
//     }
//     return slots;
//   };

//   // Check if a time slot is booked
//   const isSlotBooked = (date, time) => {
//     const dateStr = date.toISOString().split('T')[0];
//     return bookings.some(booking => {
//       if (booking.date !== dateStr) return false;
//       const bookingStart = booking.startTime;
//       const bookingEnd = booking.endTime;
//       return time >= bookingStart && time < bookingEnd;
//     });
//   };

//   // Get booking info for a slot
//   const getSlotBooking = (date, time) => {
//     const dateStr = date.toISOString().split('T')[0];
//     return bookings.find(booking => {
//       if (booking.date !== dateStr) return false;
//       const bookingStart = booking.startTime;
//       const bookingEnd = booking.endTime;
//       return time >= bookingStart && time < bookingEnd;
//     });
//   };

//   // Check for overlapping bookings
//   const hasOverlap = (date, startTime, endTime, excludeId = null) => {
//     const dateStr = date.toISOString().split('T')[0];
//     return bookings.some(booking => {
//       if (booking.id === excludeId) return false;
//       if (booking.date !== dateStr) return false;
      
//       const bookingStart = booking.startTime;
//       const bookingEnd = booking.endTime;
      
//       return (startTime < bookingEnd && endTime > bookingStart);
//     });
//   };

//   // Calculate duration in minutes
//   const getDurationInMinutes = (startTime, endTime) => {
//     const [startHour, startMin] = startTime.split(':').map(Number);
//     const [endHour, endMin] = endTime.split(':').map(Number);
    
//     const startMinutes = startHour * 60 + startMin;
//     const endMinutes = endHour * 60 + endMin;
    
//     return endMinutes - startMinutes;
//   };

//   // Handle booking submission
//   const handleBookingSubmit = () => {
    
//     const { startTime, endTime, description, date } = bookingForm;
    
//     if (!startTime || !endTime || !description || !date) {
//       alert('Please fill in all fields');
//       return;
//     }
    
//     const duration = getDurationInMinutes(startTime, endTime);
    
//     if (duration < 30) {
//       alert('Minimum booking duration is 30 minutes');
//       return;
//     }
    
//     if (duration > 120) {
//       alert('Maximum booking duration is 2 hours');
//       return;
//     }
    
//     const bookingDate = new Date(date);
//     const today = new Date();
//     const maxDate = new Date(today.getTime() + 6 * 24 * 60 * 60 * 1000);
    
//     if (bookingDate > maxDate) {
//       alert('Bookings can only be made for the next 7 days');
//       return;
//     }
    
//     if (hasOverlap(bookingDate, startTime, endTime, editingBooking?.id)) {
//       alert('This time slot overlaps with an existing booking');
//       return;
//     }
    
//     if (editingBooking) {
//       // Update existing booking
//       setBookings(prev => prev.map(booking => 
//         booking.id === editingBooking.id 
//           ? { ...booking, date, startTime, endTime, description }
//           : booking
//       ));
//       setEditingBooking(null);
//     } else {
//       // Create new booking
//       const newBooking = {
//         id: Date.now(),
//         userId: user.id,
//         userName: user.name,
//         date,
//         startTime,
//         endTime,
//         description,
//         status: 'confirmed'
//       };
//       setBookings(prev => [...prev, newBooking]);
//     }
    
//     setShowBookingModal(false);
//     setBookingForm({ startTime: '', endTime: '', description: '', date: '' });
//   };

//   // Handle booking cancellation
//   const handleCancelBooking = (bookingId) => {
//     if (window.confirm('Are you sure you want to cancel this booking?')) {
//       setBookings(prev => prev.filter(booking => booking.id !== bookingId));
//     }
//   };

//   // Handle booking edit
//   const handleEditBooking = (booking) => {
//     setEditingBooking(booking);
//     setBookingForm({
//       startTime: booking.startTime,
//       endTime: booking.endTime,
//       description: booking.description,
//       date: booking.date
//     });
//     setShowBookingModal(true);
//   };

//   // Open booking modal
//   const openBookingModal = (date) => {
//     setBookingForm({
//       ...bookingForm,
//       date: date.toISOString().split('T')[0]
//     });
//     setShowBookingModal(true);
//   };

//   // Get user's bookings
//   const getUserBookings = () => {
//     return bookings.filter(booking => booking.userId === user.id);
//   };

//   const weekDates = getWeekDates();
//   const timeSlots = generateTimeSlots();

//   return (
//     <Layout sidebar={<Sidebar sidebarLinks={ConferenceRoomItem} />}>
//       {/* Added padding on all sides for gap */}
//       <div className="p-6 space-y-6">
//         {/* Header */}
//         <div className="flex justify-between items-center">
//           <div>
//             <h2 className="text-xl font-semibold text-gray-800">Meeting Room Calendar</h2>
//             <p className="text-gray-600">Book and manage your meeting room slots</p>
//           </div>
//           <button
//             onClick={() => openBookingModal(new Date())}
//             className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2"
//           >
//             <Plus size={20} />
//             <span>New Booking</span>
//           </button>
//         </div>

//         {/* Calendar Grid */}
//         <div className="bg-white rounded-lg shadow border border-gray-200">
//           <div className="p-4 border-b">
//             <div className="flex justify-between items-center">
//               <h3 className="text-lg font-medium">Weekly View</h3>
//               <div className="flex space-x-4 text-sm">
//                 <div className="flex items-center space-x-2">
//                   <div className="w-3 h-3 bg-green-500 rounded border border-green-600"></div>
//                   <span>Available</span>
//                 </div>
//                 <div className="flex items-center space-x-2">
//                   <div className="w-3 h-3 bg-red-500 rounded border border-red-600"></div>
//                   <span>Booked</span>
//                 </div>
//                 <div className="flex items-center space-x-2">
//                   <div className="w-3 h-3 bg-blue-500 rounded border border-blue-600"></div>
//                   <span>Your Bookings</span>
//                 </div>
//               </div>
//             </div>
//           </div>
          
//           <div className="overflow-x-auto">
//             <table className="w-full border-separate border-spacing-1">
//               <thead>
//                 <tr className="border-b">
//                   <th className="text-left p-3 w-20 border border-gray-200 bg-gray-50 rounded">Time</th>
//                   {weekDates.map(date => (
//                     <th key={date.toISOString()} className="text-center p-3 min-w-32 border border-gray-200 bg-gray-50 rounded">
//                       <div className="font-medium">{date.toLocaleDateString('en-US', { weekday: 'short' })}</div>
//                       <div className="text-sm text-gray-600">{date.getDate()}</div>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {timeSlots.map(time => (
//                   <tr key={time} className="hover:bg-gray-50">
//                     <td className="p-3 text-sm font-medium text-gray-600 border border-gray-200 bg-gray-50 rounded">{time}</td>
//                     {weekDates.map(date => {
//                       const isBooked = isSlotBooked(date, time);
//                       const booking = getSlotBooking(date, time);
//                       const isUserBooking = booking?.userId === user.id;
//                       const isToday = date.toDateString() === new Date().toDateString();
                      
//                       return (
//                         <td key={`${date.toISOString()}-${time}`} className="p-1">
//                           <div
//                             className={`
//                               h-8 rounded cursor-pointer border-2 transition-colors m-1
//                               ${isBooked 
//                                 ? isUserBooking 
//                                   ? 'bg-blue-500 border-blue-600 shadow-sm' 
//                                   : 'bg-red-500 border-red-600 shadow-sm'
//                                 : 'bg-green-500 border-green-600 hover:bg-green-600 shadow-sm'
//                               }
//                               ${isToday ? 'ring-2 ring-yellow-400' : ''}
//                             `}
//                             onClick={() => !isBooked && openBookingModal(date)}
//                             title={
//                               isBooked 
//                                 ? `${booking.userName}: ${booking.description} (${booking.startTime}-${booking.endTime})`
//                                 : 'Available - Click to book'
//                             }
//                           >
//                             {isBooked && (
//                               <div className="text-white text-xs p-1 truncate">
//                                 {booking.userName}
//                               </div>
//                             )}
//                           </div>
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* My Bookings */}
//         <div className="bg-white rounded-lg shadow border border-gray-200">
//           <div className="p-4 border-b border-gray-200">
//             <h3 className="text-lg font-medium">My Bookings</h3>
//           </div>
//           <div className="p-4">
//             {getUserBookings().length === 0 ? (
//               <p className="text-gray-500 text-center py-8">No bookings found</p>
//             ) : (
//               <div className="space-y-3">
//                 {getUserBookings()
//                   .sort((a, b) => new Date(a.date + ' ' + a.startTime) - new Date(b.date + ' ' + b.startTime))
//                   .map(booking => (
//                     <div key={booking.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200">
//                       <div className="flex items-center space-x-3">
//                         <Calendar size={18} className="text-gray-600" />
//                         <div>
//                           <div className="font-medium">{booking.description}</div>
//                           <div className="text-sm text-gray-600">
//                             {new Date(booking.date).toLocaleDateString()} • {booking.startTime} - {booking.endTime}
//                           </div>
//                         </div>
//                       </div>
//                       <div className="flex space-x-2">
//                         <button
//                           onClick={() => handleEditBooking(booking)}
//                           className="text-blue-600 hover:text-blue-800 p-1 border border-transparent rounded hover:border-blue-200 hover:bg-blue-50"
//                           title="Edit booking"
//                         >
//                           <Edit2 size={16} />
//                         </button>
//                         <button
//                           onClick={() => handleCancelBooking(booking.id)}
//                           className="text-red-600 hover:text-red-800 p-1 border border-transparent rounded hover:border-red-200 hover:bg-red-50"
//                           title="Cancel booking"
//                         >
//                           <Trash2 size={16} />
//                         </button>
//                       </div>
//                     </div>
//                   ))}
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Booking Modal */}
//         {showBookingModal && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//             <div className="bg-white rounded-lg p-6 w-full max-w-md border border-gray-200 shadow-lg">
//               <div className="flex justify-between items-center mb-4">
//                 <h3 className="text-lg font-medium">
//                   {editingBooking ? 'Edit Booking' : 'New Booking'}
//                 </h3>
//                 <button
//                   onClick={() => {
//                     setShowBookingModal(false);
//                     setEditingBooking(null);
//                     setBookingForm({ startTime: '', endTime: '', description: '', date: '' });
//                   }}
//                   className="text-gray-500 hover:text-gray-700 p-1 rounded border border-transparent hover:border-gray-200 hover:bg-gray-50"
//                 >
//                   <X size={20} />
//                 </button>
//               </div>
              
//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Date
//                   </label>
//                   <input
//                     type="date"
//                     value={bookingForm.date}
//                     onChange={(e) => setBookingForm({ ...bookingForm, date: e.target.value })}
//                     min={new Date().toISOString().split('T')[0]}
//                     max={new Date(Date.now() + 6 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]}
//                     className="w-full p-2 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                     required
//                   />
//                 </div>
                
//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Start Time
//                     </label>
//                     <select
//                       value={bookingForm.startTime}
//                       onChange={(e) => setBookingForm({ ...bookingForm, startTime: e.target.value })}
//                       className="w-full p-2 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       required
//                     >
//                       <option value="">Select time</option>
//                       {timeSlots.map(time => (
//                         <option key={time} value={time}>{time}</option>
//                       ))}
//                     </select>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       End Time
//                     </label>
//                     <select
//                       value={bookingForm.endTime}
//                       onChange={(e) => setBookingForm({ ...bookingForm, endTime: e.target.value })}
//                       className="w-full p-2 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       required
//                     >
//                       <option value="">Select time</option>
//                       {timeSlots.map(time => (
//                         <option key={time} value={time}>{time}</option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
                
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Description
//                   </label>
//                   <textarea
//                     value={bookingForm.description}
//                     onChange={(e) => setBookingForm({ ...bookingForm, description: e.target.value })}
//                     placeholder="Enter meeting purpose or description"
//                     rows={3}
//                     className="w-full p-2 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                     required
//                   />
//                 </div>
                
//                 <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
//                   <button
//                     type="button"
//                     onClick={() => {
//                       setShowBookingModal(false);
//                       setEditingBooking(null);
//                       setBookingForm({ startTime: '', endTime: '', description: '', date: '' });
//                     }}
//                     className="px-4 py-2 text-gray-600 border-2 border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="button"
//                     onClick={handleBookingSubmit}
//                     className="px-4 py-2 bg-blue-600 text-white border-2 border-blue-600 rounded-lg hover:bg-blue-700 hover:border-blue-700"
//                   >
//                     {editingBooking ? 'Update' : 'Book'} Meeting
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </Layout>
//   );
// };

// export default MeetingRoomBooking;


import React, { useState, useEffect, useContext } from 'react';
import { Calendar, Clock, Users, Plus, X, Edit2, Trash2, Check, AlertCircle, RefreshCw } from 'lucide-react';
import { message } from 'antd';
import Layout from "../components/Layout";
import { Sidebar } from "../components";
import AuthContext from "../contexts/AuthContext";
import {ConferenceRoomItem} from "../data";

// API base URL - adjust according to your Django setup
const API_BASE_URL = 'https://ess-api-django-a6fc2c26f42e.herokuapp.com/api/lms/conference';

// Sidebar items for meeting room booking
const BookingMenuItems = [
  { name: 'Meeting Room Booking', icon: Calendar, path: '/booking/calendar' }
];

const MeetingRoomBooking = () => {
  const { authTokens, user } = useContext(AuthContext);

  const apiCall = async (endpoint, options = {}) => {
    // const token = localStorage.getItem('authToken'); 
    const url = `${API_BASE_URL}${endpoint}`;
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: "Bearer " + String(authTokens.access),
      },
      ...options,
    };

    if (config.body && typeof config.body === 'object') {
      config.body = JSON.stringify(config.body);
    }

    const response = await fetch(url, config);
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Network error' }));
      throw new Error(errorData.error || errorData.message || `HTTP ${response.status}`);
    }
    
    return response.json();
  };

  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [bookings, setBookings] = useState([]);
  const [calendarData, setCalendarData] = useState({
    dates: [],
    time_slots: [],
    bookings: {}
  });
  const [rooms, setRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(1);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [bookingForm, setBookingForm] = useState({
    room: 1,
    startTime: '',
    endTime: '',
    description: '',
    date: ''
  });
  const [editingBooking, setEditingBooking] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tooltip, setTooltip] = useState({ show: false, content: '', x: 0, y: 0 });

  // Message API instance
  const [messageApi, contextHolder] = message.useMessage();

  // Fetch meeting rooms
  const fetchRooms = async () => {
    try {
      const data = await apiCall('/rooms/');
      setRooms(data);
      if (data.length > 0) {
        setSelectedRoom(data[0].id);
      }
      // messageApi.success('Meeting rooms loaded successfully');
    } catch (err) {
      console.error('Error fetching rooms:', err);
      messageApi.error('Failed to load meeting rooms');
    }
  };

  // Fetch weekly calendar data
  const fetchWeeklyCalendar = async (startDate = null, roomId = null) => {
    try {
      setLoading(true);
      const dateStr = startDate ? startDate.toISOString().split('T')[0] : currentDate.toISOString().split('T')[0];
      const room = roomId || selectedRoom;
      
      const data = await apiCall(`/bookings/weekly_calendar/?start_date=${dateStr}&room_id=${room}`);
      setCalendarData(data);
      // messageApi.success('Calendar data refreshed');
    } catch (err) {
      console.error('Error fetching calendar data:', err);
      messageApi.error('Failed to load calendar data');
    } finally {
      setLoading(false);
    }
  };

  // Fetch user's bookings
  const fetchMyBookings = async () => {
    try {
      const data = await apiCall('/bookings/my_bookings/');
      setBookings(data);
      // messageApi.success('Your bookings loaded successfully');
    } catch (err) {
      console.error('Error fetching bookings:', err);
      messageApi.error('Failed to load your bookings');
    }
  };

  // Check availability
  const checkAvailability = async (roomId, date, startTime, endTime, excludeId = null) => {
    try {
      const data = await apiCall('/bookings/check_availability/', {
        method: 'POST',
        body: {
          room_id: roomId,
          date: date,
          start_time: startTime,
          end_time: endTime,
          exclude_booking_id: excludeId
        }
      });
      return data;
    } catch (err) {
      console.error('Error checking availability:', err);
      return { available: false, message: err.message };
    }
  };

  // Initialize data
  useEffect(() => {
    fetchRooms();
  }, []);

  useEffect(() => {
    if (selectedRoom) {
      fetchWeeklyCalendar();
      fetchMyBookings();
    }
  }, [selectedRoom, currentDate]);

  // Generate week dates starting from current date
  const getWeekDates = () => {
  if (calendarData.dates && calendarData.dates.length > 0) {
    // Filter to show only weekdays (Monday to Friday)
    return calendarData.dates
      .map(dateStr => new Date(dateStr))
      .filter(date => {
        const dayOfWeek = date.getDay();
        return dayOfWeek >= 1 && dayOfWeek <= 5; // 1 = Monday, 5 = Friday
      });
  }
  
  // Fallback to generate weekdays only
  const dates = [];
  const startDate = new Date(currentDate);
  
  // Find the Monday of current week
  const dayOfWeek = startDate.getDay();
  const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Handle Sunday (0) case
  startDate.setDate(startDate.getDate() + mondayOffset);
  
  // Generate Monday to Friday (5 days)
  for (let i = 0; i < 5; i++) {
    const date = new Date(startDate);
    date.setDate(startDate.getDate() + i);
    dates.push(date);
  }
  return dates;
};

  // Get time slots
  const getTimeSlots = () => {
  if (calendarData.time_slots && calendarData.time_slots.length > 0) {
    // Filter the API response to show only 30-minute intervals (00 and 30 minutes)
    return calendarData.time_slots.filter(time => {
      const minutes = time.split(':')[1];
      return minutes === '00' || minutes === '30';
    });
  }
  // Fallback to generate 30-minute time slots
  const slots = [];
  for (let hour = 10; hour < 19; hour++) {
    slots.push(`${hour.toString().padStart(2, '0')}:00`);
    slots.push(`${hour.toString().padStart(2, '0')}:30`);
  }
  return slots;
};

  // Check if a time slot is booked
  const isSlotBooked = (date, time) => {
  const dateStr = date.toISOString().split('T')[0];
  const dayBookings = calendarData.bookings[dateStr] || [];
  
  // Convert current slot time to minutes for comparison
  const [currentHour, currentMin] = time.split(':').map(Number);
  const currentSlotStart = currentHour * 60 + currentMin;
  const currentSlotEnd = currentSlotStart + 30; // 30-minute slot duration
  
  return dayBookings.some(booking => {
    const [startHour, startMin] = booking.start_time.split(':').map(Number);
    const [endHour, endMin] = booking.end_time.split(':').map(Number);
    
    const bookingStart = startHour * 60 + startMin;
    const bookingEnd = endHour * 60 + endMin;
    
    // Check if booking overlaps with current 30-minute slot
    return (bookingStart < currentSlotEnd && bookingEnd > currentSlotStart);
  });
};


  // Get booking info for a slot
  const getSlotBooking = (date, time) => {
  const dateStr = date.toISOString().split('T')[0];
  const dayBookings = calendarData.bookings[dateStr] || [];
  
  // Convert current slot time to minutes for comparison
  const [currentHour, currentMin] = time.split(':').map(Number);
  const currentSlotStart = currentHour * 60 + currentMin;
  const currentSlotEnd = currentSlotStart + 30; // 30-minute slot duration
  
  return dayBookings.find(booking => {
    const [startHour, startMin] = booking.start_time.split(':').map(Number);
    const [endHour, endMin] = booking.end_time.split(':').map(Number);
    
    const bookingStart = startHour * 60 + startMin;
    const bookingEnd = endHour * 60 + endMin;
    
    // Check if booking overlaps with current 30-minute slot
    return (bookingStart < currentSlotEnd && bookingEnd > currentSlotStart);
  });
};

  // Calculate duration in minutes
  const getDurationInMinutes = (startTime, endTime) => {
    const [startHour, startMin] = startTime.split(':').map(Number);
    const [endHour, endMin] = endTime.split(':').map(Number);
    
    const startMinutes = startHour * 60 + startMin;
    const endMinutes = endHour * 60 + endMin;
    
    return endMinutes - startMinutes;
  };

  // Handle booking submission
  const handleBookingSubmit = async () => {
    const { room, startTime, endTime, description, date } = bookingForm;
    
    if (!startTime || !endTime || !description || !date) {
      messageApi.error('Please fill in all fields');
      return;
    }
    
    const duration = getDurationInMinutes(startTime, endTime);
    
    if (duration < 30) {
      messageApi.error('Minimum booking duration is 30 minutes');
      return;
    }
    
    if (duration > 120) {
      messageApi.error('Maximum booking duration is 2 hours');
      return;
    }
    
    const bookingDate = new Date(date);
    const today = new Date();
    const maxDate = new Date(today.getTime() + 6 * 24 * 60 * 60 * 1000);
    
    if (bookingDate > maxDate) {
      messageApi.error('Bookings can only be made for the next 7 days');
      return;
    }

    // Check availability
    const availability = await checkAvailability(
      room, 
      date, 
      startTime, 
      endTime, 
      editingBooking?.id
    );
    
    if (!availability.available) {
      messageApi.error(availability.message);
      return;
    }

    try {
      setLoading(true);
      
      if (editingBooking) {
        // Update existing booking
        await apiCall(`/bookings/${editingBooking.id}/`, {
          method: 'PUT',
          body: {
            room: room,
            date: date,
            start_time: startTime,
            end_time: endTime,
            description: description
          }
        });
        messageApi.success('Booking updated successfully!');
      } else {
        // Create new booking
        await apiCall('/bookings/', {
          method: 'POST',
          body: {
            room: room,
            date: date,
            start_time: startTime,
            end_time: endTime,
            description: description
          }
        });
        messageApi.success('Meeting room booked successfully!');
      }
      
      // Refresh data
      await fetchWeeklyCalendar();
      await fetchMyBookings();
      
      setShowBookingModal(false);
      setEditingBooking(null);
      setBookingForm({ room: selectedRoom, startTime: '', endTime: '', description: '', date: '' });
      
    } catch (err) {
      messageApi.error(`Failed to ${editingBooking ? 'update' : 'create'} booking: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Handle booking cancellation
  const handleCancelBooking = async (bookingId) => {
    if (window.confirm('Are you sure you want to cancel this booking?')) {
      try {
        setLoading(true);
        await apiCall(`/bookings/${bookingId}/`, {
          method: 'DELETE'
        });
        
        messageApi.success('Booking cancelled successfully!');
        
        // Refresh data
        await fetchWeeklyCalendar();
        await fetchMyBookings();
        
      } catch (err) {
        messageApi.error(`Failed to cancel booking: ${err.message}`);
      } finally {
        setLoading(false);
      }
    }
  };

  // Handle booking edit
  const handleEditBooking = (booking) => {
    setEditingBooking(booking);
    setBookingForm({
      room: booking.room || selectedRoom,
      startTime: booking.start_time,
      endTime: booking.end_time,
      description: booking.description,
      date: booking.date
    });
    setShowBookingModal(true);
    messageApi.info('Editing booking - make your changes and click Update');
  };

  // Open booking modal
  const openBookingModal = (date) => {
    setBookingForm({
      room: selectedRoom,
      startTime: '',
      endTime: '',
      description: '',
      date: date.toISOString().split('T')[0]
    });
    setShowBookingModal(true);
    // messageApi.info('Fill in the details to book a meeting room');
  };

  // Handle mouse enter for tooltip
  const handleMouseEnter = (e, booking) => {
    const rect = e.target.getBoundingClientRect();
    setTooltip({
      show: true,
      content: booking,
      x: rect.left + rect.width / 2,
      y: rect.top - 10
    });
  };

  // Handle mouse leave for tooltip
  const handleMouseLeave = () => {
    setTooltip({ show: false, content: '', x: 0, y: 0 });
  };

  // Navigate weeks
const navigateWeek = (direction) => {
  const newDate = new Date(currentDate);
  newDate.setDate(currentDate.getDate() + (direction * 7));
  
  // Check if trying to navigate to next week (future)
  if (direction > 0) {
    const today = new Date();
    const currentWeekStart = new Date(today);
    const dayOfWeek = today.getDay();
    const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    currentWeekStart.setDate(today.getDate() + mondayOffset);
    
    const newWeekStart = new Date(newDate);
    const newDayOfWeek = newDate.getDay();
    const newMondayOffset = newDayOfWeek === 0 ? -6 : 1 - newDayOfWeek;
    newWeekStart.setDate(newDate.getDate() + newMondayOffset);
    
    // If trying to go beyond current week
    if (newWeekStart > currentWeekStart) {
      messageApi.error("You can only lock slots for the current week.");
      return;
    }
  }
  
  setCurrentDate(newDate);
  messageApi.info(`Navigating to week of ${newDate.toLocaleDateString()}`);
};
  // Handle room selection change
  const handleRoomChange = (roomId) => {
    setSelectedRoom(parseInt(roomId));
    const selectedRoomName = rooms.find(room => room.id === parseInt(roomId))?.name;
    messageApi.info(`Switched to ${selectedRoomName}`);
  };

  // Refresh data manually
  const handleRefresh = async () => {
    messageApi.loading('Refreshing data...', 1);
    try {
      await Promise.all([
        fetchWeeklyCalendar(),
        fetchMyBookings()
      ]);
    } catch (err) {
      messageApi.error('Failed to refresh data');
    }
  };

  const weekDates = getWeekDates();
  const timeSlots = getTimeSlots();

  return (
    <Layout sidebar={<Sidebar sidebarLinks={ConferenceRoomItem} />}>
      {contextHolder}
      <div className="p-6 space-y-6">
        {/* Header */}
        <div className="flex justify-between items-center">
          <div>
            <h2 className="text-xl font-semibold text-gray-800">Meeting Room Calendar</h2>
            <p className="text-gray-600">Book and manage your meeting room slots</p>
          </div>
          <div className="flex items-center space-x-4">
            {/* Room Selector */}
            <select
              value={selectedRoom}
              onChange={(e) => handleRoomChange(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              {rooms.map(room => (
                <option key={room.id} value={room.id}>
                  {room.name} ({room.capacity} people)
                </option>
              ))}
            </select>
            
            <button
              onClick={() => openBookingModal(new Date())}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2"
              disabled={loading}
            >
              <Plus size={20} />
              <span>New Booking</span>
            </button>
          </div>
        </div>

        {/* Calendar Grid */}
        <div className="bg-white rounded-lg shadow border border-gray-200">
          <div className="p-4 border-b">
            <div className="flex justify-between items-center">
              <div className="flex items-center space-x-4">
                <h3 className="text-lg font-medium">Weekly View</h3>
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() => navigateWeek(-1)}
                    className="p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded"
                    disabled={loading}
                  >
                    ←
                  </button>
                  <span className="text-sm text-gray-600 min-w-32 text-center">
                    {weekDates.length > 0 && `${weekDates[0].toLocaleDateString()} - ${weekDates[4].toLocaleDateString()}`}
                  </span>
                  <button
                    onClick={() => navigateWeek(1)}
                    className="p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded"
                    disabled={loading}
                  >
                    →
                  </button>
                  {loading && <RefreshCw className="animate-spin text-gray-400" size={16} />}
                </div>
              </div>
              
              <div className="flex space-x-4 text-sm">
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-green-500 rounded border border-green-600"></div>
                  <span>Available</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-red-500 rounded border border-red-600"></div>
                  <span>Booked</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-blue-500 rounded border border-blue-600"></div>
                  <span>Your Bookings</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="overflow-x-auto">
            <table className="w-full border-separate border-spacing-1">
              <thead>
                <tr className="border-b">
                  <th className="text-left p-3 w-20 border border-gray-200 bg-gray-50 rounded">Time</th>
                  {weekDates.map(date => (
                    <th key={date.toISOString()} className="text-center p-3 min-w-32 border border-gray-200 bg-gray-50 rounded">
                      <div className="font-medium">{date.toLocaleDateString('en-US', { weekday: 'short' })}</div>
                      <div className="text-sm text-gray-600">{date.getDate()}</div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {timeSlots.map(time => (
                  <tr key={time} className="hover:bg-gray-50">
                    <td className="p-3 text-sm font-medium text-gray-600 border border-gray-200 bg-gray-50 rounded">{time}</td>
                    {weekDates.map(date => {
                      const isBooked = isSlotBooked(date, time);
                      const booking = getSlotBooking(date, time);
                      const isUserBooking = booking?.is_own_booking;
                      const isToday = date.toDateString() === new Date().toDateString();
                      
                      return (
                        <td key={`${date.toISOString()}-${time}`} className="p-1">
                          <div
                            className={`
                              h-8 rounded cursor-pointer border-2 transition-colors m-1 relative
                              ${isBooked 
                                ? isUserBooking 
                                  ? 'bg-blue-500 border-blue-600 shadow-sm' 
                                  : 'bg-red-500 border-red-600 shadow-sm'
                                : 'bg-green-500 border-green-600 hover:bg-green-600 shadow-sm'
                              }
                              ${isToday ? 'ring-2 ring-yellow-400' : ''}
                            `}
                            onClick={() => !isBooked && openBookingModal(date)}
                            onMouseEnter={(e) => isBooked && handleMouseEnter(e, booking)}
                            onMouseLeave={handleMouseLeave}
                          >
                            {isBooked && (
                              <div className="text-white text-xs p-1 truncate">
                                {booking.user_name}
                              </div>
                            )}
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Tooltip */}
        {tooltip.show && tooltip.content && (
          <div
            className="fixed z-50 bg-gray-900 text-white text-sm p-3 rounded-lg shadow-lg max-w-xs"
            style={{
              left: `${tooltip.x}px`,
              top: `${tooltip.y}px`,
              transform: 'translateX(-50%) translateY(-100%)',
              pointerEvents: 'none'
            }}
          >
            <div className="font-medium">{tooltip.content.user_name}</div>
            <div className="text-gray-300">{tooltip.content.description}</div>
            <div className="text-gray-400 text-xs">
              {tooltip.content.start_time} - {tooltip.content.end_time}
            </div>
          </div>
        )}

        {/* My Bookings */}
        <div className="bg-white rounded-lg shadow border border-gray-200">
          <div className="p-4 border-b border-gray-200">
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-medium">My Bookings</h3>
              <button
                onClick={handleRefresh}
                className="text-gray-600 hover:text-gray-800 p-1 rounded hover:bg-gray-100"
                disabled={loading}
              >
                <RefreshCw className={loading ? 'animate-spin' : ''} size={16} />
              </button>
            </div>
          </div>
          <div className="p-4">
            {bookings.length === 0 ? (
              <p className="text-gray-500 text-center py-8">No bookings found</p>
            ) : (
              <div className="space-y-3">
                {bookings
                  .sort((a, b) => new Date(a.date + ' ' + a.start_time) - new Date(b.date + ' ' + b.start_time))
                  .map(booking => (
                    <div key={booking.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200">
                      <div className="flex items-center space-x-3">
                        <Calendar size={18} className="text-gray-600" />
                        <div>
                          <div className="font-medium">{booking.description}</div>
                          <div className="text-sm text-gray-600">
                            {booking.room_name} • {new Date(booking.date).toLocaleDateString()} • {booking.start_time} - {booking.end_time}
                          </div>
                          <div className="text-xs text-gray-500">
                            Status: <span className="capitalize">{booking.status}</span>
                          </div>
                        </div>
                      </div>
                      {booking.status === 'confirmed' && (
                        <div className="flex space-x-2">
                          <button
                            onClick={() => handleEditBooking(booking)}
                            className="text-blue-600 hover:text-blue-800 p-1 border border-transparent rounded hover:border-blue-200 hover:bg-blue-50"
                            title="Edit booking"
                            disabled={loading}
                          >
                            <Edit2 size={16} />
                          </button>
                          <button
                            onClick={() => handleCancelBooking(booking.id)}
                            className="text-red-600 hover:text-red-800 p-1 border border-transparent rounded hover:border-red-200 hover:bg-red-50"
                            title="Cancel booking"
                            disabled={loading}
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>

        {/* Booking Modal */}
        {showBookingModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg p-6 w-full max-w-md border border-gray-200 shadow-lg">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-medium">
                  {editingBooking ? 'Edit Booking' : 'New Booking'}
                </h3>
                <button
                  onClick={() => {
                    setShowBookingModal(false);
                    setEditingBooking(null);
                    setBookingForm({ room: selectedRoom, startTime: '', endTime: '', description: '', date: '' });
                    // messageApi.info('Booking form closed');
                  }}
                  className="text-gray-500 hover:text-gray-700 p-1 rounded border border-transparent hover:border-gray-200 hover:bg-gray-50"
                >
                  <X size={20} />
                </button>
              </div>
              
              <div className="space-y-4">
                {/* Room Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Meeting Room
                  </label>
                  <select
                    value={bookingForm.room}
                    onChange={(e) => setBookingForm({ ...bookingForm, room: parseInt(e.target.value) })}
                    className="w-full p-2 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    required
                  >
                    {rooms.map(room => (
                      <option key={room.id} value={room.id}>
                        {room.name} ({room.capacity} people) - {room.location}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Date
                  </label>
                  <input
                    type="date"
                    value={bookingForm.date}
                    onChange={(e) => setBookingForm({ ...bookingForm, date: e.target.value })}
                    min={new Date().toISOString().split('T')[0]}
                    max={new Date(Date.now() + 6 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]}
                    className="w-full p-2 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    required
                  />
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Start Time
                    </label>
                    <select
                      value={bookingForm.startTime}
                      onChange={(e) => setBookingForm({ ...bookingForm, startTime: e.target.value })}
                      className="w-full p-2 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      required
                    >
                      <option value="">Select time</option>
                      {timeSlots.map(time => (
                        <option key={time} value={time}>{time}</option>
                      ))}
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      End Time
                    </label>
                    <select
                      value={bookingForm.endTime}
                      onChange={(e) => setBookingForm({ ...bookingForm, endTime: e.target.value })}
                      className="w-full p-2 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      required
                    >
                      <option value="">Select time</option>
                      {timeSlots.map(time => (
                        <option key={time} value={time}>{time}</option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Description
                  </label>
                  <textarea
                    value={bookingForm.description}
                    onChange={(e) => setBookingForm({ ...bookingForm, description: e.target.value })}
                    placeholder="Enter meeting purpose or description"
                    rows={3}
                    className="w-full p-2 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    required
                  />
                </div>
                
                <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
                  <button
                    type="button"
                    onClick={() => {
                      setShowBookingModal(false);
                      setEditingBooking(null);
                      setBookingForm({ room: selectedRoom, startTime: '', endTime: '', description: '', date: '' });
                      messageApi.info('Booking form cancelled');
                    }}
                    className="px-4 py-2 text-gray-600 border-2 border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400"
                    disabled={loading}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={handleBookingSubmit}
                    className="px-4 py-2 bg-blue-600 text-white border-2 border-blue-600 rounded-lg hover:bg-blue-700 hover:border-blue-700 flex items-center space-x-2"
                    disabled={loading}
                  >
                    {loading && <RefreshCw className="animate-spin" size={16} />}
                    <span>{editingBooking ? 'Update' : 'Book'} Meeting</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default MeetingRoomBooking;